const updates = [
  {
    date: '2026.07.28',
    title: '《她的私密教学》第128话更新',
    desc: '人气韩漫最新话已上线，剧情迎来重大转折，评论区热议不断。',
    tag: '韩漫更新',
    tagColor: 'primary',
  },
  {
    date: '2026.07.27',
    title: '《剑道独尊》第95话热更中',
    desc: '国漫玄幻巨作持续高能，主角突破境界引爆读者讨论，本周热度飙升。',
    tag: '国漫热更',
    tagColor: 'accent',
  },
  {
    date: '2026.07.26',
    title: '悬疑新作《第七夜》正式上线',
    desc: '日漫悬疑区迎来重磅新作，烧脑剧情搭配精美画风，开篇即获高分好评。',
    tag: '新作上线',
    tagColor: 'primary',
  },
  {
    date: '2026.07.25',
    title: '《甜蜜的陷阱》突破200万热度',
    desc: '都市恋爱漫画口碑持续发酵，本周进入人气排行榜前五，读者安利不断。',
    tag: '热度飙升',
    tagColor: 'accent',
  },
  {
    date: '2026.07.24',
    title: '《末日生存法则》全集收录完成',
    desc: '末日题材经典日漫全集已上线虫虫漫画，新读者可一次性畅读完整故事。',
    tag: '全集上线',
    tagColor: 'primary',
  },
  {
    date: '2026.07.23',
    title: '阅读体验优化升级完成',
    desc: '下拉式阅读加载速度提升30%，图片清晰度全面优化，阅读更流畅。',
    tag: '平台公告',
    tagColor: 'secondary',
  },
  {
    date: '2026.07.22',
    title: '国漫专区新增20部人气作品',
    desc: '虫虫漫画国漫区持续扩仓，玄幻、都市、古风等多题材新作纷纷入驻。',
    tag: '专区更新',
    tagColor: 'accent',
  },
  {
    date: '2026.07.21',
    title: '《诡异调查员》作者访谈发布',
    desc: '独家对话人气悬疑漫画作者，揭秘创作幕后故事与未来剧情走向。',
    tag: '特别企划',
    tagColor: 'primary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            更新动态
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画最新上架、热更与平台资讯速递</p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex gap-4 pb-5 mb-5 border-b border-background-200/50 last:border-b-0 last:pb-0 last:mb-0"
            >
              <div className="flex-shrink-0 w-[72px] md:w-[80px]">
                <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tagColor === 'accent'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}